<template id="dashboardTmpl">
    <ct-main-layout-appgui :backurl="backurl" :breadcrumbs="breadcrumbs" >

		<v-card>
			<!-- TITLE -->
			<v-card-title>{{$t('lbl.organizations')}}</v-card-title>
		
			<v-card-text>
				<v-data-table v-if="organizations != null && organizations != []"  :headers="headersOrganizations"  :items="organizations"  :no-data-text="$t('err.noelem')"  :loading="$root.loading"  class="elevation-1">
					<template v-slot:body="{ items }">
						<tbody>
							<tr v-for="item in items" :key="item.organization_id" >
								<td class="font-weight-bold">{{ item.organization_name }}</td>
								
								<td width="20%" class="text-right">
									<v-tooltip top> 
										<template v-slot:activator="{ on, attrs }">
											<v-btn 
												class="button-secondary" fab small depressed 
												v-bind="attrs"
												v-on="on" 
												@click="$root.goToPage('/appgui/organization/' + item.organization_id)"
												><v-icon>zoom_in</v-icon></v-btn>
										</template>
										<span>{{ $t('btn.details')}}</span>
									</v-tooltip>		
								</td>
							</tr>
						</tbody>
					</template>
				</v-data-table>

				<div v-else>{{$t('err.noSitesFound')}}</div>

			</v-card-text>
		</v-card>

    </ct-main-layout-appgui>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
	data: () => ({
		backurl: '/apps',
		breadcrumbs:[],
		headersOrganizations: [
			{ text: i18n.t('lbl.organizations'), align: 'left', value: 'organization_name'},
			{ text: '', align: 'center'},
		],
		organizations: [],
	}),
	components: 
	{
      
	},
	mounted() 
	{
		//=== NAVIGATION BAR
		this.breadcrumbs = [
			{ text: i18n.t('breadcrumb.appgui'), disabled: false, href: '/tools/appgui' }
		]
		
		//=== LISTENERS
		events.$on(constants.EVENT_CHANGE_LOCALE, () => {
			this.headersOrganizations = [
				{ text: i18n.t('lbl.organizations'), align: 'left', value: 'organization_name'},
				{ text: '', align: 'center'},	
			]
		});

		//=== STARTUP
		this.loadOrganizations();
	},
	destroyed() 
	{
		//=== STOP LISTEN EVENTS
		events.$off(constants.EVENT_CHANGE_LOCALE);
	},
	methods: 
	{
		loadOrganizations() 
		{
			this.organizations = [];
			//console.log(constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS);
			this.$root.genericGetAuthenticatedCallEngine(constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS, this.callbackLoadOrganizations, 'err.loadingSites');
		},
		callbackLoadOrganizations(responseData) 
		{
			//console.log(responseData);
			if(!this.isEmptyObj(responseData))
			{
				this.organizations = responseData;	
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingSites"));
			}
		}			
	}
}
</script>